import { render, staticRenderFns } from "./MusicCollectionCard.vue?vue&type=template&id=41237f12"
import script from "./MusicCollectionCard.vue?vue&type=script&lang=js"
export * from "./MusicCollectionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports